import { DeathsAndDiseasesDto, UpdateDeathsAndDiseasesDto } from 'src/dto/deaths-and-diseases.dto'
import { DeathsAndDiseasesService } from 'src/services/api/deaths-and-diseases.service'

export class DeathsAndDiseasesController {
  private service: DeathsAndDiseasesService

  constructor() {
    this.service = new DeathsAndDiseasesService()
  }

  public async getDeathsAndDiseasesList(farmId: string): Promise<DeathsAndDiseasesDto[]> {
    const response = await this.service.getDeathsAndDiseasesList(farmId)
    return response.data
  }

  public async updateDeathsAndDiseases(
    farmId: string,
    deathsAndDiseasesDto: UpdateDeathsAndDiseasesDto
  ): Promise<DeathsAndDiseasesDto> {
    const response = await this.service.updateDeathsAndDiseases(farmId, deathsAndDiseasesDto)
    return response.data
  }
}
